import React from 'react';

import styles from './EmptyState.module.scss';
import waiting from '../../constants/images/detailsOrder/waiting.svg';

const EmptyState = ({icon, title, description}) => {
    return (
        <div className={styles.emptyState}>
            <img src={icon} alt="no items"/>

            <div className={styles.emptyState_description}>
                <p className={styles.emptyState_description_title}>{title}</p>
                <p className={styles.emptyState_description_subtitle}>{description}</p>
            </div>
        </div>
    );
};

export default EmptyState;
